"use strict";

exports.__esModule = true;
exports.MockParams = void 0;
exports.mockFeatureFormat = mockFeatureFormat;
exports.mockFeatureRetrieve = mockFeatureRetrieve;
exports.mockFormat = mockFormat;
exports.mockRetrieve = mockRetrieve;
exports.mockWinnersFormat = mockWinnersFormat;
exports.mockWinnersRetrieve = mockWinnersRetrieve;
let MockParams = exports.MockParams = /*#__PURE__*/function (MockParams) {
  MockParams["MOCK_TEST"] = "darwin_mock_test";
  MockParams["MOCK_FEATURE_ON"] = "darwin_mock_feature_on";
  MockParams["MOCK_FEATURE_OFF"] = "darwin_mock_feature_off";
  MockParams["MOCK_WINNER"] = "darwin_mock_winner";
  return MockParams;
}({});
function mockFormat(tests, path) {
  if (path === void 0) {
    path = window.location.search;
  }
  const url = new URL(`https://localhost.com${path}`);
  url.searchParams.delete(MockParams.MOCK_TEST);
  tests.forEach(_ref => {
    let {
      name,
      value
    } = _ref;
    // Please lord, let people not use dunders in test names or values
    url.searchParams.append(MockParams.MOCK_TEST, `${name}__${value}`);
  });
  return url.search;
}
function mockRetrieve(path) {
  const url = new URL(`https://localhost.com${path}`);
  return Array.from(url.searchParams.getAll(MockParams.MOCK_TEST).map(pair => pair.split("__")).map(_ref2 => {
    let [name, value] = _ref2;
    return [encodeURIComponent(name), encodeURIComponent(value)];
  }) // prevent XSS
  .map(_ref3 => {
    let [name, value] = _ref3;
    return {
      name,
      value
    };
  }));
}
function mockFeatureFormat(features, path) {
  if (path === void 0) {
    path = window.location.search;
  }
  const url = new URL(`https://localhost.com${path}`);
  url.searchParams.delete(MockParams.MOCK_FEATURE_ON);
  url.searchParams.delete(MockParams.MOCK_FEATURE_OFF);
  Object.entries(features).forEach(_ref4 => {
    let [name, on] = _ref4;
    if (on) {
      url.searchParams.append(MockParams.MOCK_FEATURE_ON, name);
    } else {
      url.searchParams.append(MockParams.MOCK_FEATURE_OFF, name);
    }
  });
  return url.search;
}
function mockFeatureRetrieve(path) {
  const url = new URL(`https://localhost.com${path}`);
  const res = {};
  url.searchParams.forEach((val, key) => {
    const encodedVal = encodeURIComponent(val); // prevent XSS

    if (key === MockParams.MOCK_FEATURE_ON) {
      // eslint-disable-next-line fp/no-mutation
      res[encodedVal] = true;
    }
    if (key === MockParams.MOCK_FEATURE_OFF) {
      // eslint-disable-next-line fp/no-mutation
      res[encodedVal] = false;
    }
  });
  return res;
}
function mockWinnersFormat(tests, path) {
  if (path === void 0) {
    path = window.location.search;
  }
  const url = new URL(`https://localhost.com${path}`);
  url.searchParams.delete(MockParams.MOCK_WINNER);
  tests.forEach(_ref5 => {
    let {
      name,
      value
    } = _ref5;
    // Please lord, let people not use dunders in test names or values
    url.searchParams.append(MockParams.MOCK_WINNER, `${name}__${value}`);
  });
  return url.search;
}
function mockWinnersRetrieve(path) {
  const url = new URL(`https://localhost.com${path}`);
  return Array.from(url.searchParams.getAll(MockParams.MOCK_WINNER).map(pair => pair.split("__")).map(_ref6 => {
    let [name, value] = _ref6;
    return [encodeURIComponent(name), encodeURIComponent(value)];
  }) // prevent XSS
  .map(_ref7 => {
    let [name, value] = _ref7;
    return {
      name,
      value
    };
  }));
}